module.exports = __webpack_public_path__ + "assets/img/lbg.d9fc8198.jpg";